/* tslint:disable */
/* eslint-disable */
/**
 * Appli métier
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: Yoda 1 & 2
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { Configuration } from "../configuration"
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from "axios"
import globalAxios from "axios"
// Some imports not used depending on template conditions
// @ts-ignore
import {
  DUMMY_BASE_URL,
  assertParamExists,
  setApiKeyToObject,
  setBasicAuthToObject,
  setBearerAuthToObject,
  setOAuthToObject,
  setSearchParams,
  serializeDataIfNeeded,
  toPathString,
  createRequestFunction,
  replaceWithSerializableTypeIfNeeded
} from "../common"
// @ts-ignore
import {
  BASE_PATH,
  COLLECTION_FORMATS,
  type RequestArgs,
  BaseAPI,
  RequiredError,
  operationServerMap
} from "../base"
// @ts-ignore
import type { Advisor } from "../model"
// @ts-ignore
import type { RegisAssociation } from "../model"
/**
 * AssociationResourceV2Api - axios parameter creator
 */
export const AssociationResourceV2ApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     *
     * @summary Get association by id
     * @param {string} associationId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getAssociation: async (
      associationId: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'associationId' is not null or undefined
      assertParamExists("getAssociation", "associationId", associationId)
      const localVarPath = `/v2.0/associations/{associationId}`.replace(
        "{associationId}",
        encodeURIComponent(String(associationId))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "GET", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication oauth2 required
      // oauth required
      await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)

      localVarHeaderParameter["Accept"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     *
     * @summary Get collaborators by association id
     * @param {string} associationId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getAssociationCollaborators: async (
      associationId: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'associationId' is not null or undefined
      assertParamExists("getAssociationCollaborators", "associationId", associationId)
      const localVarPath = `/v2.0/associations/{associationId}/collaborators`.replace(
        "{associationId}",
        encodeURIComponent(String(associationId))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "GET", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication oauth2 required
      // oauth required
      await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)

      localVarHeaderParameter["Accept"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     *
     * @summary Get all associations
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getAssociations: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
      const localVarPath = `/v2.0/associations`
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "GET", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication oauth2 required
      // oauth required
      await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)

      localVarHeaderParameter["Accept"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    },
    /**
     *
     * @summary Migrate deposits by association id and contact id
     * @param {string} associationId
     * @param {string} [contactId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    migrateDeposits: async (
      associationId: string,
      contactId?: string,
      options: RawAxiosRequestConfig = {}
    ): Promise<RequestArgs> => {
      // verify required parameter 'associationId' is not null or undefined
      assertParamExists("migrateDeposits", "associationId", associationId)
      const localVarPath = `/v2.0/associations/{associationId}/migrate-deposit`.replace(
        "{associationId}",
        encodeURIComponent(String(associationId))
      )
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL)
      let baseOptions
      if (configuration) {
        baseOptions = configuration.baseOptions
      }

      const localVarRequestOptions = { method: "POST", ...baseOptions, ...options }
      const localVarHeaderParameter = {} as any
      const localVarQueryParameter = {} as any

      // authentication oauth2 required
      // oauth required
      await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)

      if (contactId !== undefined) {
        localVarQueryParameter["contactId"] = contactId
      }

      localVarHeaderParameter["Accept"] = "application/json"

      setSearchParams(localVarUrlObj, localVarQueryParameter)
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {}
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers
      }

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions
      }
    }
  }
}

/**
 * AssociationResourceV2Api - functional programming interface
 */
export const AssociationResourceV2ApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = AssociationResourceV2ApiAxiosParamCreator(configuration)
  return {
    /**
     *
     * @summary Get association by id
     * @param {string} associationId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getAssociation(
      associationId: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RegisAssociation>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getAssociation(
        associationId,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["AssociationResourceV2Api.getAssociation"]?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Get collaborators by association id
     * @param {string} associationId
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getAssociationCollaborators(
      associationId: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Advisor>>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getAssociationCollaborators(
        associationId,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["AssociationResourceV2Api.getAssociationCollaborators"]?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Get all associations
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async getAssociations(
      options?: RawAxiosRequestConfig
    ): Promise<
      (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<RegisAssociation>>
    > {
      const localVarAxiosArgs = await localVarAxiosParamCreator.getAssociations(options)
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["AssociationResourceV2Api.getAssociations"]?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    },
    /**
     *
     * @summary Migrate deposits by association id and contact id
     * @param {string} associationId
     * @param {string} [contactId]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async migrateDeposits(
      associationId: string,
      contactId?: string,
      options?: RawAxiosRequestConfig
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.migrateDeposits(
        associationId,
        contactId,
        options
      )
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0
      const localVarOperationServerBasePath =
        operationServerMap["AssociationResourceV2Api.migrateDeposits"]?.[
          localVarOperationServerIndex
        ]?.url
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration
        )(axios, localVarOperationServerBasePath || basePath)
    }
  }
}

/**
 * AssociationResourceV2Api - factory interface
 */
export const AssociationResourceV2ApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance
) {
  const localVarFp = AssociationResourceV2ApiFp(configuration)
  return {
    /**
     *
     * @summary Get association by id
     * @param {AssociationResourceV2ApiGetAssociationRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getAssociation(
      requestParameters: AssociationResourceV2ApiGetAssociationRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<RegisAssociation> {
      return localVarFp
        .getAssociation(requestParameters.associationId, options)
        .then(request => request(axios, basePath))
    },
    /**
     *
     * @summary Get collaborators by association id
     * @param {AssociationResourceV2ApiGetAssociationCollaboratorsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getAssociationCollaborators(
      requestParameters: AssociationResourceV2ApiGetAssociationCollaboratorsRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<Array<Advisor>> {
      return localVarFp
        .getAssociationCollaborators(requestParameters.associationId, options)
        .then(request => request(axios, basePath))
    },
    /**
     *
     * @summary Get all associations
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getAssociations(options?: RawAxiosRequestConfig): AxiosPromise<Array<RegisAssociation>> {
      return localVarFp.getAssociations(options).then(request => request(axios, basePath))
    },
    /**
     *
     * @summary Migrate deposits by association id and contact id
     * @param {AssociationResourceV2ApiMigrateDepositsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    migrateDeposits(
      requestParameters: AssociationResourceV2ApiMigrateDepositsRequest,
      options?: RawAxiosRequestConfig
    ): AxiosPromise<string> {
      return localVarFp
        .migrateDeposits(requestParameters.associationId, requestParameters.contactId, options)
        .then(request => request(axios, basePath))
    }
  }
}

/**
 * Request parameters for getAssociation operation in AssociationResourceV2Api.
 */
export interface AssociationResourceV2ApiGetAssociationRequest {
  readonly associationId: string
}

/**
 * Request parameters for getAssociationCollaborators operation in AssociationResourceV2Api.
 */
export interface AssociationResourceV2ApiGetAssociationCollaboratorsRequest {
  readonly associationId: string
}

/**
 * Request parameters for migrateDeposits operation in AssociationResourceV2Api.
 */
export interface AssociationResourceV2ApiMigrateDepositsRequest {
  readonly associationId: string

  readonly contactId?: string
}

/**
 * AssociationResourceV2Api - object-oriented interface
 */
export class AssociationResourceV2Api extends BaseAPI {
  /**
   *
   * @summary Get association by id
   * @param {AssociationResourceV2ApiGetAssociationRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public getAssociation(
    requestParameters: AssociationResourceV2ApiGetAssociationRequest,
    options?: RawAxiosRequestConfig
  ) {
    return AssociationResourceV2ApiFp(this.configuration)
      .getAssociation(requestParameters.associationId, options)
      .then(request => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Get collaborators by association id
   * @param {AssociationResourceV2ApiGetAssociationCollaboratorsRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public getAssociationCollaborators(
    requestParameters: AssociationResourceV2ApiGetAssociationCollaboratorsRequest,
    options?: RawAxiosRequestConfig
  ) {
    return AssociationResourceV2ApiFp(this.configuration)
      .getAssociationCollaborators(requestParameters.associationId, options)
      .then(request => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Get all associations
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public getAssociations(options?: RawAxiosRequestConfig) {
    return AssociationResourceV2ApiFp(this.configuration)
      .getAssociations(options)
      .then(request => request(this.axios, this.basePath))
  }

  /**
   *
   * @summary Migrate deposits by association id and contact id
   * @param {AssociationResourceV2ApiMigrateDepositsRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  public migrateDeposits(
    requestParameters: AssociationResourceV2ApiMigrateDepositsRequest,
    options?: RawAxiosRequestConfig
  ) {
    return AssociationResourceV2ApiFp(this.configuration)
      .migrateDeposits(requestParameters.associationId, requestParameters.contactId, options)
      .then(request => request(this.axios, this.basePath))
  }
}
